<script>
  /**
   * 編集対象データのスキーマを元にダイアログを表示し、入力内容を firebase に保存する
   */
  import firebase from 'firebase/app'

  import { filterPermittedFields } from '../../scheme'

  import ModalCard from '../ModalCard.svelte'

  export let name
  export let title
  export let scheme

  let modal // モーダル コンポーネント

  let doc // 編集中の運転日報
  let ref = null // 編集中のドキュメントへのリファレンス
  let colRef = null // 運転日報コレクションへのリファレンス

  // 編集可能フィールドの抽出
  const fields = filterPermittedFields(scheme)

  // モーダルを開く
  export const open = args => {
    // 初期値の設定
    ;({ ref, colRef, ...doc } = args)
    modal.show()
  }

  // 入力した内容の確認
  const confirmHandler = () => {
    // ドキュメント リファレンスがあるか、コレクション リファレンスがあるかで処理を変える
    if (ref) {
      // ドキュメント リファレンスでドキュメントを更新
      //  (存在しないドキュメントへのリファレンスなら新規作成になる)
      ref.set({
        createAt: firebase.firestore.FieldValue.serverTimestamp(), // 新規作成の場合のタイムスタンプ。既存ドキュメントならスプレッド構文で上書きされる
        ...doc,
        updateAt: firebase.firestore.FieldValue.serverTimestamp(),
      })
      return true
    } else {
      // コレクション リファレンスに新規ドキュメントを作成
      colRef.add({
        ...doc,
        createAt: firebase.firestore.FieldValue.serverTimestamp(),
      })
      return true
    }
  }
</script>

<ModalCard
  {name}
  title={`${title}-${ref ? '編集' : '作成'}`}
  buttonText="保存"
  disableHeader={true}
  {confirmHandler}
  bind:this={modal}
>
  {#if doc}
    <!-- 各編集フィールドの表示 -->
    {#each fields as field}
      <!-- 管理者用フィールドはBG色を付けて表示 -->
      <div
        class="box"
        data-testid={`${name}-${field.name}Box`}
        class:has-background-warning-light={field.isSecret}
      >
        <svelte:component
          this={field.editor.component}
          bind:value={doc[field.name]}
          name={field.name}
          label={field.label}
          {...field.editor.props}
        />
      </div>
    {/each}
  {/if}
</ModalCard>
